<script>
export default {
  methods: {
    formatPrice(price, currency) {
      return new Intl.NumberFormat(this.$fischer.siteLanguage(), {
        style: 'currency',
        currency,
        ...(price % 1 === 0
          ? {
              maximumFractionDigits: 0,
              minimumFractionDigits: 0,
            }
          : {}),
      }).format(price);
    },
  },
};
</script>
